/** The room's device codes and walls, shared by ScreenClient and ScreenSelector (split out of ScreenClient.jsx, #1166). */



export const VALID_SCREEN_CODES = ['A1', 'A2', 'B1', 'B2', 'C1', 'C2', 'D1', 'D2'];

export const VALID_IPAD_CODES = ['P1', 'P2', 'P3', 'P4', 'P5', 'P6', 'P7', 'P8', 'P9', 'P10', 'P11', 'P12', 'P13', 'P14', 'P15'];

export const VALID_DEVICE_CODES = [...VALID_SCREEN_CODES, ...VALID_IPAD_CODES];

export const WALLS = [
  { id: 'A', name: 'Pohjoinen', screens: ['A1', 'A2'] },
  { id: 'B', name: 'Itä', screens: ['B1', 'B2'] },
  { id: 'C', name: 'Etelä', screens: ['C1', 'C2'] },
  { id: 'D', name: 'Länsi', screens: ['D1', 'D2'] },
];

/** Maps wall id → locale key under `screenClient` */
export const WALL_COMPASS_KEY = {
  A: 'wallNorth',
  B: 'wallEast',
  C: 'wallSouth',
  D: 'wallWest',
};
